// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { UserListResponse } from "./types";

import * as userActions from "./user.actions";

export function* getUser(
  action: ReturnType<typeof userActions.getUserAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'users';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: UserListResponse = yield call(result.json.bind(result));
      yield put(userActions.getUserAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userActions.getUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(userActions.getUserAsync.failure(parsed));
  }
}

export default function* userSagaGetUser() {
  yield takeEvery(userActions.getUserAsync.request, getUser);
}
